<template>
  <div>
    <el-row type="flex" justify="end">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="OnCreatePrivInsForm"
        v-if="!isView"
        round
      >
        Agregar Dependiente
      </el-button>
    </el-row>
    <el-row>
      <rabbey-table-3
        :data="PrivInsReportData"
        :columns="PrivInsColumns"
        :actions="PrivInsactions"
        :loading="privInsLoading"
        @rtable-push-action="actionHandler"
      />
    </el-row>
    <AddNewDependent
      :NewDependentFormView="NewDependentFormView"
      :EmployeeInfo="GetEmployeeInfo"
      :ActualDependentInfo="actualDependentInfo"
      :Command="command"
      @onCloseNewDependentForm="onCloseNewDependentForm"
      @PrivateInsuranceAdded="PrivateInsuranceAdded"
    />
  </div>
</template>

<script>
import {
  PrivInsColumns,
  PrivInsactions
} from "@/views/apps/employees/profiles/PrivateInsurance/PrivInsColumns/PrivInsColumns.js";
import AddNewDependent from "@/views/apps/employees/profiles/PrivateInsurance/AddNewDependent.vue";
import { mapGetters } from "vuex";
import { number } from "yargs";

export default {
  name: "PrivateInsurance",
  components: {
    AddNewDependent
  },
  props: {
    isView: {
      type: Boolean,
      default: false
    },
    KeyTabs: {
      type: number,
      default: 0
    },
    EmpleeInfo: {
      type: Object,
      default: () => {}
    },
    actualTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      PrivInsReportData: [],
      PrivInsColumns: PrivInsColumns,
      PrivInsactions: PrivInsactions,
      privInsLoading: false,
      NewDependentFormView: false,
      keyTab: this.KeyTabs,
      actualDependentInfo: {},
      command: ""
    };
  },
  async mounted() {
    await this.GetPrivateInsuranceDependents();
  },
  computed: {
    ...mapGetters({
      getEmployee: "employees/getEmployee",
      getActualLefTab: "employees/getActualLefTab"
    }),
    GetEmployeeInfo() {
      return this.EmpleeInfo;
    },
    PrivInsReportDataFiltered() {
      let PrivInsReportDataFiltered = this.PrivInsReportData; //.filter(pi => pi.)
      return PrivInsReportDataFiltered;
    }
  },
  methods: {
    actionHandler(action) {
      this.actualDependentInfo = action.row;
      switch (action.command) {
        case "edit_insurance": {
          this.command = action.command;
          this.NewDependentFormView = true;
          break;
        }
        case "delete_insurance": {
          this.DeleteDependent(action.row);
          break;
        }
      }
    },
    OnCreatePrivInsForm() {
      this.NewDependentFormView = true;
    },
    onCloseNewDependentForm() {
      this.CleanCommand();
      this.NewDependentFormView = false;
      this.GetPrivateInsuranceDependents();
    },
    async GetPrivateInsuranceDependents() {
      this.privInsLoading = true;
      let body = {};
      if (this.keyTab == 1) {
        body = {
          params: {
            EmployeeId: this.getEmployee.ID,
            insuranceType: 1 //
          }
        };
      } else if (this.keyTab == 2) {
        body = {
          params: {
            EmployeeId: this.getEmployee.ID,
            insuranceType: 0
          }
        };
      }

      await this.$http
        .get("/api/CXC/GetPrivateInsuranceDependents", body)
        .then((resp) => {
          this.PrivInsReportData = resp.data;
        })
        .catch((err) => {
          console.error(err);
        });
      this.privInsLoading = false;
    },
    async PrivateInsuranceAdded() {
      this.CleanCommand();
      this.NewDependentFormView = false;
      await this.GetPrivateInsuranceDependents();
    },
    async RecalculatePayroll() {
      let body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {
          this.$message.success("CxcAgregado");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async DeleteDependent(row) {
      const body = {
        Id: row.Id,
        insuranceType: row.insuranceType
      };
      await this.$http
        .put("/api/CXC/DeleteDependent", body)
        .then(async () => {
          await this.RecalculatePayroll();
          await this.GetPrivateInsuranceDependents();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    CleanCommand() {
      this.command = "";
    }
    /*,
    ResetNewDependentForm() {
      this.actualDependentInfo = {
        Name: "",
        Identification: "",
        relationship: "",
        Amount: "",
        FixedDiscount: true,
        FromDate: "",
        ToDate: "",
        Biweekly: "2"
      }
    }
      */
  },
  watch: {
    async getActualLefTab() {
      this.PrivInsReportDataFiltered = [];
      await this.GetPrivateInsuranceDependents();
    } /*,
    async actualTab() {
      this.PrivInsReportDataFiltered = []
      await this.GetPrivateInsuranceDependents();
    }
    */
  }
};
</script>

<style></style>
